import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import "@mdi/font/css/materialdesignicons.css";
import pinia from "./stores";
import "vue3-toastify/dist/index.css";
import "@/assets/css/main.css";
import "@/assets/css/main-card.css";
import "@/assets/css/sales.css";
import "@/assets/css/achievement.css";
import "@/assets/css/consigmentValue.css";
import "@/assets/css/fcst-style.css";
import "@/assets/css/invoice.css";
import "@/assets/css/items.css";
import "@/assets/css/login-form.css";
import "@/assets/css/openOrder.css";
import "@/assets/css/overview-style.css";
import "@/assets/css/purchasing.css";
// 👇 Fix ResizeObserver loop error
window.addEventListener("error", (e) => {
  if (
    e.message ===
      "ResizeObserver loop completed with undelivered notifications." ||
    e.message === "ResizeObserver loop limit exceeded"
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

// 👇 import vue-echarts component
import VChart from "vue-echarts";

// ECharts core
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart, LineChart, BarChart, GaugeChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";

use([
  CanvasRenderer,
  PieChart,
  LineChart,
  BarChart,
  GaugeChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

const app = createApp(App);

app.use(router).use(vuetify).use(pinia);

// 👇 register global component
app.component("v-chart", VChart);

app.mount("#app");
